const MERGE_PAGE_DATA = 'MERGE_PAGE_DATA';
const SET_PAGE_DATA = 'SET_PAGE_DATA';
const SHOW_SPA_PAGE_LOAD_PROGRESS = 'SHOW_SPA_PAGE_LOAD_PROGRESS';

export {
    MERGE_PAGE_DATA, SET_PAGE_DATA, SHOW_SPA_PAGE_LOAD_PROGRESS
};
